/**
 * List of Colombian tax liabilities.
 * @type {{id: string, name: string}[]}
 */
export default [
  { id: 'big_taxpayer', name: 'Gran contribuyente' },
  { id: 'auto_withholder', name: 'Autorretenedor' },
  { id: 'vat_withholding_agent', name: 'Agente de retención de IVA' },
  { id: 'simple_regime', name: 'Régimen simple' },
  { id: 'non_responsible', name: 'No responsable' },
  { id: 'non_applicable', name: 'No aplica' }
]
